import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledIcon = styled(FontAwesomeIcon)`
  & {
    height: 2.4rem;
    width: 2.4rem;
    color: ${({ theme }) => theme.colors.grey[600]};
  }
`;

export const StyledModalTitle = styled.span`
  font-size: 2.4rem;
  margin-left: 0.7rem;
`;

export const StyledWarningBoxWrapper = styled.div`
  margin-top: 1.6rem;
`;

export const StyledWarningIcon = styled(FontAwesomeIcon)`
  & {
    height: 2rem;
    width: 2rem;
    color: ${({ theme }) => theme.colors.warning.light};
  }
`;

export const StyledWarnText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
`;
